// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dr-j";
export var fulfillmentFormRail = "_dr-i";
export var headerTitleRow = "_dr-l";
export var orderDetailsWrapper = "_dr-g";
export var orderLinkTrigger = "_dr-2";
export var paymentInformationGrid = "_dr-q";
export var paymentSummaryColumn = "_dr-r";
export var phoneShipmentPickerButton = "_dr-e";
export var phoneShipmentPickerButtonContent = "_dr-f";
export var phoneShipmentPickerButtonWrapper = "_dr-d";
export var phoneShipmentPickerTrigger = "_dr-c";
export var shipmentContainer = "_dr-k";
export var shipmentDetailsMainPane = "_dr-h";
export var shipmentNavigationCard = "_dr-a";
export var shipmentNavigationEdgeTrigger = "_dr-6";
export var shipmentNavigationRail = "_dr-3";
export var shipmentNavigationRailEnter = "_dr-5";
export var shipmentNavigationRailHeader = "_dr-9";
export var shipmentNavigationRailOverlay = "_dr-4";
export var shipmentNavigationScrim = "_dr-7";
export var shipmentSummaryFact = "_dr-n";
export var shipmentSummaryGrid = "_dr-m";
export var shipmentSummaryMetadataRow = "_dr-o";
export var shipmentSummaryTags = "_dr-p";
export var shipmentWorkspace = "_dr-0";
export var shipmentWorkspaceBodyTablet = "_dr-8";
export var shipmentWorkspaceContent = "_dr-b";
export var shipmentWorkspaceHeader = "_dr-1";